export default __webpack_public_path__ + "static/media/gift.fd811ad5.png";